import { Component, input, viewChild } from '@angular/core';
import { IColumn } from '@app/shared/interfaces/column.interface';
import { TableComponent } from '@shared/components/table-component/table.component';
import { IFiltredDashboardResponse } from '@app/shared/interfaces/dashboard.interface';
import { ExcelButtonComponent } from '@app/shared/components/excel-button/excel-button.component';
import { CommonModule } from '@angular/common';
import { CardComponent } from '@app/shared/components/card/card.component';

@Component({
    selector: 'app-agent-information',
    imports: [CommonModule, TableComponent, ExcelButtonComponent, CardComponent],
    templateUrl: './agent-information.component.html',
    styleUrl: './agent-information.component.scss'
})
export class AgentInformationComponent {
    priceColumnTemplate = viewChild('priceColumnTemplate');

    loading = input<boolean>(false);
    agentInformationData = input<IFiltredDashboardResponse['agentInformation']['results']>();

    cols: IColumn[] = [];

    ngOnInit() {
        this.cols = [
            { key: 'reservation', label: 'Reservation' },
            { key: 'agentName', label: 'Agent Name' },
            { key: 'adult', label: 'Adult' },
            { key: 'child', label: 'Child' },
            { key: 'infant', label: 'Infant' },
            { key: 'topSellerAirline', label: 'Top Seller Airline' },
            { key: 'revenue', label: 'Price', template: this.priceColumnTemplate() },
            { key: 'totalPax', label: 'Total Pax' },
            { key: 'lastYearPax', label: "Last Year's Pax" }
        ];
    }

    exportData(): any[] {
        return (
            this.agentInformationData()?.map((item) => ({
                reservation: item.reservation ?? '',
                agentName: item.agentName ?? '',
                adult: item.adult ?? '',
                child: item.child ?? '',
                infant: item.infant ?? '',
                topSellerAirline: item.topSellerAirline ?? '',
                revenue: `${item.revenue?.currency ?? ''} ${item.revenue?.amount?.toFixed(2) ?? ''}`,
                totalPax: item.totalPax ?? '',
                lastYearPax: item.lastYearPax ?? ''
            })) ?? []
        );
    }
}
